import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITableData } from '../models/table';
import { INotification, INotificationsCount } from '../models/notifications';

const ROOT_URL: string = '/api/v1/notifications/';

@Injectable({
	providedIn: 'root'
})
export class NotificationsService {

	constructor(
		private http: HttpClient
	) {}

	archive(params: any): Observable<void> {
		const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.http.post<void>(ROOT_URL + 'archive/', {}, { params: httpParams });
	}

	count(params: any): Observable<INotificationsCount> {
		const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.http.get<INotificationsCount>(ROOT_URL + 'counts/', { params: httpParams });
	}

	createCopyPlanogramNotification(data: any): Observable<void> {
		return this.http.post<void>(ROOT_URL + 'planogram-copy/', data);
	}

	createEquipmentEditNotification(data: any): Observable<void> {
		return this.http.post<void>(ROOT_URL + 'equipment-edit/', data);
	}

	createPlanogramRotationNotification(data: any): Observable<void> {
		return this.http.post<void>(ROOT_URL + 'product-rotation/', data);
	}

	delete(params: any): Observable<void> {
		const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.http.delete<void>(ROOT_URL, { params: httpParams });
	}

	get(id: number): Observable<INotification> {
		return this.http.get<INotification>(ROOT_URL + `${id}/`);
	}

	getList(params: any = {}): Observable<ITableData<INotification>> {
		const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.http.get<ITableData<INotification>>(ROOT_URL, { params: httpParams });
	}

	read(params: any): Observable<void> {
		const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.http.post<void>(ROOT_URL + 'mark-read/', {}, { params: httpParams });
	}

	unArchive(params: any): Observable<void> {
		const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.http.post<void>(ROOT_URL + 'unarchive/', {}, { params: httpParams });
	}
}
